// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-container {
    display: flex;
    flex-direction: column;
    height: 100vh;
  }
  
  .dashboard-layout {
    display: flex;
    flex-grow: 1;
    overflow: hidden;
    margin-top: 60px; /* Offset for the fixed header */
  }
  
  .dashboard-main {
    flex-grow: 1;
    transition: margin-left 0.3s ease;
    margin-left: 0;
  }
  
  .dashboard-main.sidebar-open {
    margin-left: 250px; 
  }
  
  .dashboard-content {
    padding: 1rem;
    background-color: #f5f5f5;
    height: calc(100% - 60px);
    overflow-y: auto;
    margin-top: 20px; 
    margin-bottom: 20px;
  }
  
  .dashboard-content h2 {
    color: #000;
    margin-top: 0;
    padding-top: 10px;
  }
  
  .dashboard-content p {
    color: #000;
    margin-top: 10px;
    padding-top: 5px;
  }
  
  .dashboard-stats {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    flex-wrap: wrap; /* Allow wrapping on smaller screens */
  }
  
  .stat-box {
    flex: 1 1;
    display: flex;
    align-items: center;
    background: #fff;
    border-radius: 8px;
    padding: 30px 20px;
    margin: 10px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    min-width: 250px; 
    background: linear-gradient(50deg, #ffcc29, #FFD95F);
  }
  
  .stat-icon {
    font-size: 2rem;
    margin-right: 20px;
    color: #007bff;
  }
  
  .stat-info {
    display: flex;
    flex-direction: column;
    align-items: start;
    width: 100%;
  }

  .stat-info-credit {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
  
  .stat-info h3 {
    margin: 0;
    font-size: 1.5rem;
    color: #333;
  }
  
  .stat-info p {
    margin: 0;
    color: #666;
  }

  .stat-info-credit h3 {
    margin: 0;
    font-size: 1.5rem;
    color: #333;
  }
  
  .stat-info-credit p {
    margin: 0;
    color: #666;
  }

  .credit-wrap {
    display: flex;
    flex-direction: column;
    text-align: left;
  }

  .dashboard-icon {
    color: #373435;
    font-size: 22px;
    margin-right: 10px;
  }
  
  /* -------------------------------- */
  .charts-container {
    display: flex;
    gap: 20px;
    margin-top: 30px;
    flex-wrap: wrap; /* Allow wrapping on smaller screens */
  }
  
  .chart-box {
    flex: 1 1;
    background-color: #fff;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    min-width: 300px; /* Ensures charts don’t shrink too much */
  }
  
  .chart-box h4 {
    text-align: center;
    margin-bottom: 20px;
  }


  /* ===================Scheduled Campaign alert message========================  */
  .report-bar {
    background-color: #44a67e;
    color: white;
    padding: 12px 20px;
    margin: 0 10px;
    border-radius: 8px;
    font-size: 16px;
    font-weight: bold;
    display: flex;
    align-items: center;
    position: relative;
    overflow: hidden;
  }
  
  .report-heading {
    flex-shrink: 0;
    margin-right: 15px;
    z-index: 1;
    white-space: nowrap;
    cursor: pointer;
  }

  .report-heading:hover {
    color: #ffcc29;
    text-decoration: underline;
  }
  
  .scrolling-wrapper {
    overflow: hidden;
    position: relative;
    width: 100%;
  }
  
  .scrolling-text {
    display: inline-block;
    white-space: nowrap;
    padding-left: 100%;
    animation: scrollText 25s linear infinite; /* Fixed duration for consistent speed */
  }
  
  @keyframes scrollText {
    from {
      transform: translateX(0%);
    }
    to {
      transform: translateX(-100%);
    }
  }
  
  
/* ===================Scheduled Campaign alert message========================  */


.alert-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.alert-popup {
  background-color: #fff;
  padding: 30px 40px;
  border-radius: 10px;
  width: 500px;
  max-width: 90%;
  position: relative;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.3);
  text-align: left;
  font-size: 16px;
  line-height: 1.5;
}

.alert-popup h2 {
  margin-top: 0;
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 15px;
  color: #000;
}

.alert-popup p {
  font-size: 16px;
  color: #373435;
}

.alert-popup .close-button {
  position: absolute;
  top: 16px;
  right: 18px;
  font-size: 30px;
  color: #fb3d4e;
  border: none;
  background: none;
  cursor: pointer;
}

.alert-popup .close-button:hover {
  font-size: 35px;
  transition: 0.3s ease;
}

.blurred {
  filter: blur(5px);
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
}



  /* Media Queries for Smaller Screens */
  @media (max-width: 850px) {
    .dashboard-main.sidebar-open {
        margin-left: 0; 
      }
  }
  
  @media (max-width: 768px) {
    .dashboard-stats {
      flex-direction: column; /* Stack stats vertically on smaller screens */
    }
  
    .charts-container {
      flex-direction: column; /* Stack charts vertically */
      gap: 10px;
    }
  
    .chart-box {
      min-width: 100%; /* Ensure charts take full width on small screens */
    }
  
    .stat-box {
      min-width: 100%; /* Ensure stat boxes take full width on small screens */
    }
  }
  
  @media (max-width: 480px) {
    .stat-box {
      padding: 20px 10px; /* Adjust padding for very small screens */
    }
  
    .chart-box {
      padding: 15px 10px; /* Adjust padding for very small screens */
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Dashboard/Dashboard.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,gBAAgB,EAAE,gCAAgC;EACpD;;EAEA;IACE,YAAY;IACZ,iCAAiC;IACjC,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,eAAe,EAAE,sCAAsC;EACzD;;EAEA;IACE,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,wCAAwC;IACxC,gBAAgB;IAChB,oDAAoD;EACtD;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,SAAS;IACT,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,SAAS;IACT,WAAW;EACb;;EAEA;IACE,SAAS;IACT,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,SAAS;IACT,WAAW;EACb;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,kBAAkB;EACpB;;EAEA,qCAAqC;EACrC;IACE,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,eAAe,EAAE,sCAAsC;EACzD;;EAEA;IACE,SAAO;IACP,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,wCAAwC;IACxC,gBAAgB,EAAE,yCAAyC;EAC7D;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;;EAGA,iFAAiF;EACjF;IACE,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,yCAAyC,EAAE,wCAAwC;EACrF;;EAEA;IACE;MACE,yBAAyB;IAC3B;IACA;MACE,4BAA4B;IAC9B;EACF;;;AAGF,iFAAiF;;;AAGjF;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;AACnB;;;;EAIE,sCAAsC;EACtC;IACE;QACI,cAAc;MAChB;EACJ;;EAEA;IACE;MACE,sBAAsB,EAAE,8CAA8C;IACxE;;IAEA;MACE,sBAAsB,EAAE,4BAA4B;MACpD,SAAS;IACX;;IAEA;MACE,eAAe,EAAE,mDAAmD;IACtE;;IAEA;MACE,eAAe,EAAE,uDAAuD;IAC1E;EACF;;EAEA;IACE;MACE,kBAAkB,EAAE,0CAA0C;IAChE;;IAEA;MACE,kBAAkB,EAAE,0CAA0C;IAChE;EACF","sourcesContent":[".dashboard-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    height: 100vh;\r\n  }\r\n  \r\n  .dashboard-layout {\r\n    display: flex;\r\n    flex-grow: 1;\r\n    overflow: hidden;\r\n    margin-top: 60px; /* Offset for the fixed header */\r\n  }\r\n  \r\n  .dashboard-main {\r\n    flex-grow: 1;\r\n    transition: margin-left 0.3s ease;\r\n    margin-left: 0;\r\n  }\r\n  \r\n  .dashboard-main.sidebar-open {\r\n    margin-left: 250px; \r\n  }\r\n  \r\n  .dashboard-content {\r\n    padding: 1rem;\r\n    background-color: #f5f5f5;\r\n    height: calc(100% - 60px);\r\n    overflow-y: auto;\r\n    margin-top: 20px; \r\n    margin-bottom: 20px;\r\n  }\r\n  \r\n  .dashboard-content h2 {\r\n    color: #000;\r\n    margin-top: 0;\r\n    padding-top: 10px;\r\n  }\r\n  \r\n  .dashboard-content p {\r\n    color: #000;\r\n    margin-top: 10px;\r\n    padding-top: 5px;\r\n  }\r\n  \r\n  .dashboard-stats {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    margin-top: 20px;\r\n    flex-wrap: wrap; /* Allow wrapping on smaller screens */\r\n  }\r\n  \r\n  .stat-box {\r\n    flex: 1;\r\n    display: flex;\r\n    align-items: center;\r\n    background: #fff;\r\n    border-radius: 8px;\r\n    padding: 30px 20px;\r\n    margin: 10px;\r\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n    min-width: 250px; \r\n    background: linear-gradient(50deg, #ffcc29, #FFD95F);\r\n  }\r\n  \r\n  .stat-icon {\r\n    font-size: 2rem;\r\n    margin-right: 20px;\r\n    color: #007bff;\r\n  }\r\n  \r\n  .stat-info {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: start;\r\n    width: 100%;\r\n  }\r\n\r\n  .stat-info-credit {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    width: 100%;\r\n  }\r\n  \r\n  .stat-info h3 {\r\n    margin: 0;\r\n    font-size: 1.5rem;\r\n    color: #333;\r\n  }\r\n  \r\n  .stat-info p {\r\n    margin: 0;\r\n    color: #666;\r\n  }\r\n\r\n  .stat-info-credit h3 {\r\n    margin: 0;\r\n    font-size: 1.5rem;\r\n    color: #333;\r\n  }\r\n  \r\n  .stat-info-credit p {\r\n    margin: 0;\r\n    color: #666;\r\n  }\r\n\r\n  .credit-wrap {\r\n    display: flex;\r\n    flex-direction: column;\r\n    text-align: left;\r\n  }\r\n\r\n  .dashboard-icon {\r\n    color: #373435;\r\n    font-size: 22px;\r\n    margin-right: 10px;\r\n  }\r\n  \r\n  /* -------------------------------- */\r\n  .charts-container {\r\n    display: flex;\r\n    gap: 20px;\r\n    margin-top: 30px;\r\n    flex-wrap: wrap; /* Allow wrapping on smaller screens */\r\n  }\r\n  \r\n  .chart-box {\r\n    flex: 1;\r\n    background-color: #fff;\r\n    padding: 20px;\r\n    border-radius: 8px;\r\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n    min-width: 300px; /* Ensures charts don’t shrink too much */\r\n  }\r\n  \r\n  .chart-box h4 {\r\n    text-align: center;\r\n    margin-bottom: 20px;\r\n  }\r\n\r\n\r\n  /* ===================Scheduled Campaign alert message========================  */\r\n  .report-bar {\r\n    background-color: #44a67e;\r\n    color: white;\r\n    padding: 12px 20px;\r\n    margin: 0 10px;\r\n    border-radius: 8px;\r\n    font-size: 16px;\r\n    font-weight: bold;\r\n    display: flex;\r\n    align-items: center;\r\n    position: relative;\r\n    overflow: hidden;\r\n  }\r\n  \r\n  .report-heading {\r\n    flex-shrink: 0;\r\n    margin-right: 15px;\r\n    z-index: 1;\r\n    white-space: nowrap;\r\n    cursor: pointer;\r\n  }\r\n\r\n  .report-heading:hover {\r\n    color: #ffcc29;\r\n    text-decoration: underline;\r\n  }\r\n  \r\n  .scrolling-wrapper {\r\n    overflow: hidden;\r\n    position: relative;\r\n    width: 100%;\r\n  }\r\n  \r\n  .scrolling-text {\r\n    display: inline-block;\r\n    white-space: nowrap;\r\n    padding-left: 100%;\r\n    animation: scrollText 25s linear infinite; /* Fixed duration for consistent speed */\r\n  }\r\n  \r\n  @keyframes scrollText {\r\n    from {\r\n      transform: translateX(0%);\r\n    }\r\n    to {\r\n      transform: translateX(-100%);\r\n    }\r\n  }\r\n  \r\n  \r\n/* ===================Scheduled Campaign alert message========================  */\r\n\r\n\r\n.alert-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  z-index: 9999;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.alert-popup {\r\n  background-color: #fff;\r\n  padding: 30px 40px;\r\n  border-radius: 10px;\r\n  width: 500px;\r\n  max-width: 90%;\r\n  position: relative;\r\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.3);\r\n  text-align: left;\r\n  font-size: 16px;\r\n  line-height: 1.5;\r\n}\r\n\r\n.alert-popup h2 {\r\n  margin-top: 0;\r\n  font-size: 22px;\r\n  font-weight: bold;\r\n  margin-bottom: 15px;\r\n  color: #000;\r\n}\r\n\r\n.alert-popup p {\r\n  font-size: 16px;\r\n  color: #373435;\r\n}\r\n\r\n.alert-popup .close-button {\r\n  position: absolute;\r\n  top: 16px;\r\n  right: 18px;\r\n  font-size: 30px;\r\n  color: #fb3d4e;\r\n  border: none;\r\n  background: none;\r\n  cursor: pointer;\r\n}\r\n\r\n.alert-popup .close-button:hover {\r\n  font-size: 35px;\r\n  transition: 0.3s ease;\r\n}\r\n\r\n.blurred {\r\n  filter: blur(5px);\r\n  pointer-events: none;\r\n  user-select: none;\r\n}\r\n\r\n\r\n\r\n  /* Media Queries for Smaller Screens */\r\n  @media (max-width: 850px) {\r\n    .dashboard-main.sidebar-open {\r\n        margin-left: 0; \r\n      }\r\n  }\r\n  \r\n  @media (max-width: 768px) {\r\n    .dashboard-stats {\r\n      flex-direction: column; /* Stack stats vertically on smaller screens */\r\n    }\r\n  \r\n    .charts-container {\r\n      flex-direction: column; /* Stack charts vertically */\r\n      gap: 10px;\r\n    }\r\n  \r\n    .chart-box {\r\n      min-width: 100%; /* Ensure charts take full width on small screens */\r\n    }\r\n  \r\n    .stat-box {\r\n      min-width: 100%; /* Ensure stat boxes take full width on small screens */\r\n    }\r\n  }\r\n  \r\n  @media (max-width: 480px) {\r\n    .stat-box {\r\n      padding: 20px 10px; /* Adjust padding for very small screens */\r\n    }\r\n  \r\n    .chart-box {\r\n      padding: 15px 10px; /* Adjust padding for very small screens */\r\n    }\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
